import history from '../../util/history'

const showDetailView = invoiceId => {
  history.push(`/invoice/${invoiceId}/detail`)

  return true
}

export default showDetailView
